import * as React from "react"
import { DemoContainer } from "@mui/x-date-pickers/internals/demo"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker"
import TextField from "@mui/material/TextField"
import MenuItem from "@mui/material/MenuItem"
import dayjs from "dayjs"
import { commonDateTimeFormat, DDMMYYYY_SLASH } from "../../utils/constants"
import { DatePicker, TimePicker } from "@mui/x-date-pickers"

const hours = Array.from({ length: 24 }, (_, i) => i)
const minutes = Array.from({ length: 60 }, (_, i) => i)

export default function DateTimePickerViewRenderers(props) {
  const {
    label,
    onChange,
    size = "small",
    name = "",
    value,
    minDateTime = dayjs(),
  } = props

  const onChangeDate = (changedDate) => {
    if (changedDate && dayjs(changedDate).isValid()) {
      let dateTime = dayjs(value).set("date", dayjs(changedDate).get("date"))
      //usign changed date because we cant select next month's date
      onChange(changedDate)
    }
  }
  const onChangeTime = (time) => {
    if (time && dayjs(time).isValid()) {
      const dateTime = dayjs(value)
        .set("hours", dayjs(time).get("hours"))
        .set("minutes", dayjs(time).get("minutes"))

      onChange(dateTime)
    }
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={["DateTimePicker", "DateTimePicker"]}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <DatePicker
            slotProps={{
              textField: {
                size,
                error: false
              }
            }}
            sx={{ width: "45%" }}
            onChange={onChangeDate}
            value={dayjs(value)}
            minDate={dayjs(minDateTime)}
            label={label + " Date"}
            name={name}
            format={DDMMYYYY_SLASH}
          />
          <TimePicker
            sx={{ width: "45%" }}
            slotProps={{ textField: { size, error: false } }}
            onChange={onChangeTime}
            value={dayjs(value)}
            timeSteps={{ minutes: 1 }}
            label={label + " Time"}
            minTime={
              dayjs(value).isSame(dayjs(), "date")
                ? dayjs()
                : dayjs().startOf("day")
            }
            name={name}
          />
        </div>
      </DemoContainer>
    </LocalizationProvider>
  )
}
